import { action } from './index';

export const PUSH_NOTIFICATION = 'PUSH_NOTIFICATION';
export const pushNotification = data => action(PUSH_NOTIFICATION, { data });

export const REMOVE_PUSH_NOTIFICATION = 'REMOVE_PUSH_NOTIFICATION';
export const removePushNotification = data => action(REMOVE_PUSH_NOTIFICATION, { data });
